import { ReactNode } from 'react'

import { Button, Col, Divider, Icon, Modal, Row } from 'common/components'

import './styles.less'

interface ConfirmModalProps {
  title: string
  visible: boolean
  content?: string
  onConfirm?: () => void
  onCancel?: () => void
  okButtonLoading?: boolean
  children?: ReactNode
  type?: 'danger' | 'warning'
  danger?: boolean
  buttonText?: string
}

const ConfirmModal = ({
  visible,
  onCancel,
  onConfirm,
  okButtonLoading,
  title,
  danger = false,
  buttonText = 'Confirm and exit',
  content,
  children,
}: ConfirmModalProps) => {
  return (
    <Modal
      className={'confirm-modal'}
      visible={visible}
      width={400}
      onCancel={onCancel}
      footer={
        <Row>
          <Col span={12}>
            <Button className="w-100" size="large" onClick={onCancel}>
              Cancel
            </Button>
          </Col>
          <Col span={12}>
            <Button
              danger={danger}
              onClick={onConfirm}
              size="large"
              type="primary"
              loading={okButtonLoading}
              className="w-100 ml-8"
            >
              {buttonText}
            </Button>
          </Col>
        </Row>
      }
    >
      <Row className="flex__direction_column flex__center">
        <div className="bg-gray-3 p-16 icon-wrapper mb-24">
          <Icon className={'fas fa-exclamation-triangle font-24'} />
        </div>
        <div>
          <p className={'title text-semi-bold color-gray-9 font-24 mb-16'}>{title}</p>
          {content && <p className={'content'}>{content}</p>}
          {children}
        </div>
        <Divider className="m-0 mt-24" />
      </Row>
    </Modal>
  )
}

export default ConfirmModal
